import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
    TextField,
    MenuItem,
    Button,
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Grid,
    TextareaAutosize,
    Autocomplete,
} from "@mui/material";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { createRicette, fetchTipo } from "../../../features/ricette/ricetteThunk";
import {
    selectIsLoading,
    selectTipo
} from '../../../features/ricette/ricetteSlice';
import { selectProdotti } from "../../../features/Prodotti/prodottiSlice";
import { fetchProdotti } from "../../../features/Prodotti/prodottiThunk";
const Textarea = styled(TextareaAutosize)`
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 5px;
    color: #160A2A;
    background: #fff;
    border: 2px solid #E5E5E5;
`;
// Updated EmptyTextarea Component
const EmptyTextarea = ({ placeholder, value, onChange }) => {
    const [inputValue, setInputValue] = useState(value || "");
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);
    const handleChange = (event) => {
        setInputValue(event.target.value);
        onChange(event);
    };
    return (
        <Textarea
            aria-label="empty textarea"
            placeholder={placeholder}
            minRows={4}
            value={inputValue}
            onChange={handleChange}
        />
    );
};
const schema = yup.object().shape({
    nome: yup.string().required("Il campo Nome è obbligatorio"),
    tipo: yup.string().required("Il campo Tipo è obbligatorio"),
    prodottoFinale: yup.mixed().required("Il campo Prodotto finale è obbligatorio"),
    stato: yup.string().required("Il campo Stato è obbligatorio"),
});
const options = ["Prova tecnica", "Destinata alla vendita"];
const RicetteForm = ({ cantine }) => {
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });
    const dispatch = useDispatch();
    const isLoading = useSelector(selectIsLoading);
    const tipo = useSelector(selectTipo);
    const prodottiId = useSelector(selectProdotti);

    
    useEffect(() => {
        dispatch(fetchTipo())
        dispatch(fetchProdotti())
    }, [dispatch])
    const onSubmit = async (data) => {
        console.log(data);
        try {
            const formData = new FormData();
            // Add regular form fields
            formData.append("company_id", localStorage.getItem("company_id"));
            formData.append("name", data?.nome);
            formData.append("tipo", data?.tipo);
            formData.append("prodotto_id", data?.prodottoFinale?.id);
            formData.append("stato", data?.stato);
            formData.append("note", data?.note);
            formData.append("cantina_id", localStorage.getItem("cantine_id"));
            // Rest of your submission code...
            if (formData) {
                //   dispatch(updateMezziData({ id: singleData?.id, data: formData }))
                //     .unwrap()
                //     .then(() => {
                //       dispatch(singleMezzi(singleData.id));
                //       reset();
                //       onClose && onClose();
                //     })
                //     .catch((err) => console.error("Update Error:", err));
                // } else {
                dispatch(createRicette(formData))
                    .unwrap().then(() => {
                        reset();
                    })
                    .catch((err) => console.error("Create Error:", err));
            }
        } catch (err) {
            console.error("Submit Error:", err);
        }
    };
    return (
        <>
            <form className="AziendaFrom" onSubmit={handleSubmit(onSubmit)}>
                <div className="AziendaFrom__inner">
                    <Typography mb={"10px"}>ID=0001</Typography>
                    <Controller
                        defaultValue=""
                        name="nome"
                        control={control}
                        render={({ field }) => (
                            <TextField className="customTextBox"
                                {...field}
                                label="Nome"
                                fullWidth
                                margin="normal"
                                error={!!errors.nome}
                                helperText={errors.nome?.message}
                            />
                        )}
                    />
                    {/* <Controller
                        name="tipo"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={tipo}
                                onChange={(event, value) => field.onChange(value)}  // To handle selected value properly
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tipo"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.tipo}
                                        helperText={errors.tipo?.message}
                                    />
                                )}
                            />
                        )}
                    /> */}
                    <Controller
                        defaultValue=""
                        name="tipo"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                options={tipo || []}
                                value={field.value || null}
                                onChange={(event, value) => field.onChange(value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Tipo"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.tipoMezzo}
                                        helperText={errors.tipoMezzo?.message}
                                    />
                                )}
                            />
                        )}
                    />
                    {/* <Controller
                        name="prodottoFinale"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={prodottiId}
                                onChange={(event, value) => field.onChange(value)}  // To handle selected value properly
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Prodotto Finale"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.prodottoFinale}
                                        helperText={errors.prodottoFinale?.message}
                                    />
                                )}
                            />
                        )}
                    /> */}
                    <Controller
                        defaultValue=""
                        name="prodottoFinale"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={prodottiId}
                                getOptionLabel={(option) => option.commercial_name || ''}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                value={field.value || null}
                                onChange={(event, value) => field.onChange(value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Prodotto Finale"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.terreno_id}
                                        helperText={errors.terreno_id?.message}
                                    />
                                )}
                            />
                        )}
                    />
                    <Controller
                        defaultValue=""
                        name="stato"
                        control={control}
                        render={({ field }) => (
                            <Autocomplete
                                {...field}
                                options={options}
                                onChange={(event, value) => field.onChange(value)}  // To handle selected value properly
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Stato"
                                        className="customTextBox autoCompleteTextBox"
                                        margin="normal"
                                        fullWidth
                                        error={!!errors.stato}
                                        helperText={errors.stato?.message}
                                    />
                                )}
                            />
                        )}
                    />
                    {/*
                    <Controller
                        name="note"
                        control={control}
                        render={({ field }) => (
                            <EmptyTextarea placeholder="Note" />
                        )}
                    /> */}
                    <Controller
                        defaultValue=""
                        name="note"
                        control={control}
                        render={({ field }) => (
                            <EmptyTextarea placeholder="Note" {...field} />
                        )}
                    />
                    <div className="btnPart1">
                        <Button type="submit" variant="contained">
                            Salva dati
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};
export default RicetteForm;